export const alertConstants = {
  PROMPT: "ALERT_PROMPT",
  SPINNER: "ALERT_SPINNER",
  SUCCESS: "ALERT_SUCCESS",
  ERROR: "ALERT_ERROR",
  CLEAR: "ALERT_CLEAR",
};
